<template>
  <v-container fill-height
               fluid
               pa-0
               style="background-image: radial-gradient(farthest-corner at 50% 50%, #004678 20%, #042345 100%); user-select: none;"
  >
    <v-row class="fill-height white--text" no-gutters>
      <v-col class="align-self-start" cols="12">
        <top-bar>
          <template v-slot:logos>
            <v-row class="fill-height flex-nowrap pt-6 pl-6" no-gutters>
              <v-col class="flex-shrink-1 pr-4" cols="auto">
                <v-img max-width="115" src="@/assets/logos/fitt_logo.svg"></v-img>
              </v-col>
              <v-col class="flex-shrink-1 " cols="auto">
                <v-img contain max-width="150" src="@/assets/logos/psychai_logo.png"></v-img>
              </v-col>
            </v-row>
          </template>
          <template v-slot:title>Edge EV (Phase 2)</template>
          <template v-slot:info>
            <v-row class="pt-8 pr-8" justify="end" no-gutters>
              <div class="title font-weight-light" v-if="timeText">Time:</div>
              <div class="title font-weight-bold mr-12 ml-2" v-if="timeText">{{ timeText }}</div>
            </v-row>
          </template>
        </top-bar>
        <v-row v-if="data" no-gutters align="center" class="px-12" dense justify="center">
          <v-col cols="12">
            <v-row class="mt-10" no-gutters justify="start" align="center">
              <v-col cols="auto">
                <back @click="reset(); $router.replace(`/${$route.params.app}/menu`)"></back>
              </v-col>
              <v-col class="title pl-3" cols="auto">
                <div class="display-1">{{ data.section_title }}</div>
              </v-col>
              <v-spacer></v-spacer>
              <v-img max-height="20"
                     max-width="20"
                     alt="coin"
                     src="@/assets/images/edge_ev_coin.svg"
              ></v-img>
              <v-img max-height="20"
                     max-width="20"
                     style="margin-left: -10px"
                     alt="coin"
                     src="@/assets/images/edge_ev_coin.svg"
              ></v-img>
              <v-img max-height="20"
                     max-width="20"
                     style="margin-left: -10px"
                     alt="coin"
                     src="@/assets/images/edge_ev_coin.svg"
              ></v-img>
              <v-col class="ml-2" cols="auto">
                <div class="text-right">{{ data.coin_text }}</div>
              </v-col>
              <v-col cols="auto" class="pl-2">
                <div class="text-center py-1"
                     style="width: 35px; border-radius: 3px"
                     :class="investmentLeft >= 0 ? 'investment-left-success' : 'investment-left-error'"
                >{{ investmentLeft }}
                </div>
              </v-col>
            </v-row>
            <div class="my-5">{{ data.description }}</div>
            <v-row justify="space-around"
                   align="center"
                   class="py-3"
                   no-gutters
                   style="border-radius: 8px; background-color: rgba(236,236,235,0.1)"
            >
              <v-col cols="auto">
                <v-row no-gutters align="center">
                  <v-img max-height="18"
                         max-width="18"
                         alt="coin"
                         src="@/assets/images/edge_ev_coin.svg"
                  ></v-img>
                  <div class="ml-2 mr-2 mb-0 text-center">
                    Some marketing investment in an area
                  </div>
                  <div class="text-center px-2"
                       style="border: 1px solid rgb(0, 176, 80); background-color: rgba(0, 176, 80, 0.3); border-radius: 4px"
                  >
                    <div class="mb-0">1 Coin</div>
                  </div>
                </v-row>
              </v-col>
              <v-col cols="auto">
                <v-row no-gutters align="center">
                  <v-img max-height="18"
                         max-width="18"
                         alt="coin"
                         src="@/assets/images/edge_ev_coin.svg"
                  ></v-img>
                  <v-img max-height="18"
                         max-width="18"
                         alt="coin"
                         src="@/assets/images/edge_ev_coin.svg"
                  ></v-img>
                  <div class="ml-2 mr-2 mb-0 text-center">
                    Significant marketing investment in an area
                  </div>
                  <div class="text-center px-2"
                       style="border: 1px solid rgb(0, 176, 80); background-color: rgba(0, 176, 80, 0.3); border-radius: 4px"
                  >
                    <div class="mb-0">2 Coins</div>
                  </div>
                </v-row>
              </v-col>
              <v-col cols="auto">
                <v-row no-gutters align="center">
                  <v-img max-height="18"
                         max-width="18"
                         alt="coin"
                         src="@/assets/images/edge_ev_coin.svg"
                  ></v-img>
                  <v-img max-height="18"
                         max-width="18"
                         alt="coin"
                         src="@/assets/images/edge_ev_coin.svg"
                  ></v-img>
                  <v-img max-height="18"
                         max-width="18"
                         alt="coin"
                         src="@/assets/images/edge_ev_coin.svg"
                  ></v-img>
                  <div class="ml-2 mr-2 mb-0 text-center">
                    Heavy marketing investment in an area
                  </div>
                  <div class="text-center px-2"
                       style="border: 1px solid rgb(0, 176, 80); background-color: rgba(0, 176, 80, 0.3); border-radius: 4px"
                  >
                    <div class="mb-0">3 Coins</div>
                  </div>
                </v-row>
              </v-col>
            </v-row>
            <div class="alert-container pt-2">
              <v-fade-transition>
                <v-alert v-if="alert.state"
                         dark
                         dense
                         text
                         :type="alert.type"
                         class="mb-0"
                >{{ alert.text }}
                </v-alert>
              </v-fade-transition>
            </div>
            <div class="ma-6" v-for="(investment_area, index) in data.investment_areas" :key="index">
              <v-row>
                <v-col cols="4">
                  <h3 class="font-weight-light">{{ investment_area.title }}</h3>
                </v-col>
                <v-col cols="8">
                  <v-slider
                      thumb-color="dark-blue"
                      tick="true"
                      tick-size="5"
                      thumb-label="always"
                      thumb-size="30"
                      dark
                      :max="3"
                      :tick-labels="data.investment_labels"
                      :track-color="investmentLeft === 0 ? 'success' : investmentLeft > 0 ? 'white' : 'error'"
                      v-model="investment_area.value"
                      @change="calculateTotal(investment_area)"
                  >
                    <template v-slot:thumb-label="{ value }">
                      <v-row justify="center">
                        <v-img v-if="value > 0"
                               max-height="18"
                               max-width="18"
                               alt="coin"
                               src="@/assets/images/edge_ev_coin.svg"
                        ></v-img>
                        <v-img v-if="value > 1"
                               max-height="18"
                               max-width="18"
                               alt="coin"
                               src="@/assets/images/edge_ev_coin.svg"
                        ></v-img>
                        <v-img v-if="value > 2"
                               max-height="18"
                               max-width="18"
                               alt="coin"
                               src="@/assets/images/edge_ev_coin.svg"
                        ></v-img>
                      </v-row>
                    </template>
                  </v-slider>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TopBar from "@/components/Framework/TopBar";
import TimerMixin from "@/views/Tools/SecPeak/Components/TimerMixin";
import Back from "@/components/Framework/Back";

export default {
  mixins: [TimerMixin],
  name: "SecPeakPhase2",
  components: {
    TopBar,
    Back,
  },
  computed: {
    alert() {
      let alert = {
        state: false,
        type: 'error',
        text: '',
      }
      if (this.investmentLeft < 0) {
        alert = {
          state: true,
          type: 'error',
          text: 'You have exceeded your total Crypto coin allowance.',
        }
      } else if (this.investmentLeft > 0 && this.investmentLeft < 10) {
        alert = {
          state: true,
          type: 'warning',
          text: 'You have unspent Crypto coins.',
        }
      } else if (this.investmentLeft === 0) {
        alert = {
          state: true,
          type: 'success',
          text: 'You have allocated all available Crypto coins.',
        }
      } else {
        alert = {
          state: false,
        }
      }

      return alert;
    }
  },
  data: () => ({
    data: null,
    selectedTotal: 0,
    investmentLeft: null,
    time: 1200000,
    timeText: '20:00',
  }),
  methods: {
    importData() {
      this.data = JSON.parse(JSON.stringify(require('@/assets/text/edge_ev_marketing.json')));
    },
    initInvestment() {
      this.investmentLeft = JSON.parse(JSON.stringify(this.data.coins));
    },
    calculateTotal() {
      this.selectedTotal = Object.values(this.data.investment_areas).reduce((previousValue, currentValue) => {
        return previousValue + currentValue.value
      }, 0)

      this.investmentLeft = this.data.coins - this.selectedTotal
    },
    reset() {
      this.selectedTotal = 0;
      this.investmentLeft = null;

      this.importData();
    },
  },
  mounted() {
    this.importData();
    this.initInvestment();
    this.startTimer();
  },
}
</script>

<style>
.v-slider__thumb {
  background-color: white !important;
}

.v-slider__tick {
  background-color: white !important;
}

.investment-left-success {
  border: 1px solid rgb(0, 176, 80);
  background-color: rgba(0, 176, 80, 0.3);
}

.investment-left-error {
  border: 1px solid rgb(152, 7, 36);
  background-color: rgba(152, 7, 36, 0.3);
}

.alert-container {
  height: 50px;
}
</style>